import { render } from "./WelcomePopup.vue?vue&type=template&id=46a8ad64&scoped=true"
import script from "./WelcomePopup.vue?vue&type=script&lang=js"
export * from "./WelcomePopup.vue?vue&type=script&lang=js"

import "./WelcomePopup.vue?vue&type=style&index=0&id=46a8ad64&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a8ad64"]])

export default __exports__